<template>
  <v-sheet
    v-if="currentPageName === 'person'"
    :color="backgroundColor"
  >
    <report-container
      v-if="reportPath !== 'profile'"
      :actions="actions"
    >
      <template v-slot:report-modals>
        <person-modal />
      </template>
    </report-container>

    <v-expand-transition v-else>
      <person-profile />
    </v-expand-transition>
  </v-sheet>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import mixin from 'src/utils/mixin'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapLayoutGetters } = createNamespacedHelpers('layout')

export default {
  name: 'Person',
  components: {
    PersonModal: () => import('src/internal/components/PersonModal'),
    PersonProfile: () => import('src/internal/components/PersonProfile'),
    ReportContainer: () => import('src/report/components/ReportContainer'),
  },
  mixins: [mixin],
  computed: {
    ...mapAuthGetters([
      'isInternalAdminUser',
    ]),
    ...mapLayoutGetters([
      'backgroundColor',
    ]),
    actions() {
      const adminActions = [
        {
          event: 'tools/updateRoute',
          name: 'View Details',
        },
        {
          event: 'internal/showFormPersonUpdate',
          name: 'Edit',
        },
        {
          event: 'internal/showFormPersonDelete',
          name: 'Delete',
        },
      ]

      return this.isInternalAdminUser ? adminActions : []
    },
  },
}
</script>
